import React, { useState } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import useDebounce from '../hooks/use-debounce';

const InputSearch = (props) => {
  const { placeholder = 'Поиск...', handleSearch, className = '', defaultValue = '', prefix, showReset } = props;
  const [searchValue, setSearchValue] = useState(defaultValue);

  const onThrottleChange = useDebounce((value) => {
    handleSearch?.(value);
  }, 1000);

  const onChange = (e) => {
    const value = e.target.value;
    onThrottleChange(value);
    setSearchValue(value);
  };

  const handleReset = () => {
    if (searchValue) {
      setSearchValue('');
      handleSearch?.('');
    }
  };

  return (
    <div className={`flex items-center bg-white border border-gray-300 rounded-lg overflow-hidden shadow-sm ${className}`}>
      {prefix && <div className={'flex px-2'}>{prefix}</div>}
      <input
        type="text"
        value={searchValue}
        onChange={onChange}
        placeholder={placeholder}
        className={`flex-1 py-2 text-sm text-gray-800 focus:outline-none ${!prefix ? 'px-3' : ''}`}
      />
      {showReset && <CloseOutlinedIcon fontSize="inherit" className={'cursor-pointer flex w-4 h-4 mr-2 text-gray-500'} onClick={handleReset} />}
    </div>
  );
};
export default InputSearch;
